import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { TextInput, Button } from "flowbite-react";
import { useGetData } from "../../../../../hooks/useGetData";
import { useMutationData } from "../../../../../hooks/useMutationData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";

export const EnvioResultadosCrearScreen = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario = "ENVÍO DE RESULTADOS";
  const [formData, setFormData] = useState({
    date: "",
  });

  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const { control, handleSubmit } = useForm();

  const mutateFechaFG = useMutationData({
    url: `/fecha_formatosgenerales/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "fecha_formatosgenerales"],
  });

  const mutateEnvioResultados = useMutationData({
    url: `/envio-resultados/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "envio-resultados"],
  });

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const navigate = useNavigate();

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className={`max-w-4xl mx-auto shadow-lg rounded-lg overflow-hidden mt-4 mb-4 relative div-ignore ${isDarkMode ? "bg-gray-800 text-white" : "bg-white"}`}>
        <form
          onSubmit={handleSubmit((data) => {
            console.log(data);

            // Aseguramos que los valores seleccionados se incluyan
            const formData = {
              ...data,
            };

            // Mutación para guardar la Fecha de Detección de Riesgos
            mutateFechaFG.mutate(
              {
                data: { fecha_envio_res: data.fecha_envio_res },
                tipo: "put",
              },
              {
                onSuccess: () => {
                  mutateEnvioResultados.mutate(
                    {
                      data: formData,
                      tipo: "put",
                    },
                    {
                      onSuccess: () => {
                        console.log("Resultados guardados con éxito");
                      },
                      onError: (error) => {
                        console.error("Error al guardar Resultados:", error);
                      },
                    }
                  );
                  navigate(`/formatosG/${evaluadosList_id}`);
                  window.scrollTo(0, 0);
                },
                onError: (error) => {
                  console.error(
                    "Error al guardar Fecha de Formatos Generales:",
                    error
                  );
                },
              }
            );
          })}
          className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800" : "bg-white"}`}
        >
          {/* Header */}
          <Header titulo={tituloFormulario} />

          {/* Contenido del formulario */}
          <div className="p-6">
            <div className="text-left mb-8">
              <h2 className={`text-xl font-bold flex items-center justify-end gap-2 ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                <span>FOLIO:</span>
                <Controller
                  name="folio_er"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextInput
                      id="folio_er"
                      type="text"
                      {...field}
                      className="text-left w-[125px]"
                    />
                  )}
                />
              </h2>
              <h2 className={`text-xl font-bold flex items-center justify-end gap-2 ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                <span>FECHA:</span>
                <Controller
                  name="fecha_envio_res"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextInput
                      id="fecha_envio_res"
                      type="date"
                      {...field}
                      className="text-left w-[125px]"
                    />
                  )}
                />
              </h2>

              <h2 className={`text-xl font-bold mb-2 flex items-center gap-2 ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                <span>NOMBRE:</span>
                <Controller
                  name="nombre_er"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextInput
                      id="nombre_er"
                      type="text"
                      {...field}
                      className="text-left w-[400px]"
                    />
                  )}
                />
              </h2>
              <h2 className={`text-xl font-bold mb-2 flex items-center gap-2 ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                <span>CARGO:</span>
                <Controller
                  name="cargo_er"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextInput
                      id="cargo_er"
                      type="text"
                      {...field}
                      className="text-left w-[400px]"
                    />
                  )}
                />
              </h2>
              <h2 className={`text-xl font-bold mb-2 flex items-center gap-2 ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                <span>EMPRESA:</span>
                <Controller
                  name="empresa_er"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextInput
                      id="empresa_er"
                      type="text"
                      {...field}
                      className="text-left w-[400px]"
                    />
                  )}
                />
              </h2>
              <h2 className={`text-xl font-bold mb-2 flex items-center gap-2 ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                <span>PRESENTE</span>
              </h2>
            </div>

            <div className="space-y-6">
              <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                <Controller
                  name="descripcion_er1"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      id="descripcion_er1"
                      {...field}
                      onInput={(e) => {
                        const target = e.target as HTMLTextAreaElement;
                        target.style.height = "auto";
                        target.style.height = `${target.scrollHeight}px`;
                      }}
                      style={{ height: "auto", overflow: "hidden" }}
                      rows={4}
                      placeholder="Escribe tus notas aquí..."
                      className={`w-full rounded-lg p-2 focus:outline-none focus:border-blue-500 resize-none ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-800 border-gray-300"}`}
                    />
                  )}
                />
              </p>

              <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                No omito comentarle que resulta de suma importancia manejar los
                resultados con las debidas medidas de seguridad, para salvaguardar
                su confidencialidad y la de los evaluados.
              </p>

              <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                Cabe señalar que los resultados emitidos, emanan del apoyo que
                presta esta empresa en cumplimiento a la normatividad aplicable a
                la misma, ello en el respectivo ámbito de nuestras competencias y
                facultades, razón por la cual los resultados de las evaluaciones
                que solicita no serán vinculatorios a las determinaciones que
                emitan al respecto. Siendo estos únicamente de carácter
                informativo donde SKA TRACKING AND SECURITY S.A. de C.V. solo
                realiza conclusiones y recomendaciones a consideración y
                valoración estrictamente de la empresa contratante.
              </p>

              <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                En espera de que esta información contribuya a fortalecer el
                cumplimiento de las acciones encomendadas, me reitero a sus
                órdenes y aprovecho la ocasión para enviarle un cordial saludo.
              </p>
            </div>
            <div className={`flex flex-col items-center mt-4 w-full ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              <span className="font-medium text-center">ATENTAMENTE</span>
              <span className="font-bold text-center">
                GONZALO FRANCISCO CARRILLO NAVARRETE
              </span>
              <span className="text-center">EN REPRESENTACIÓN LEGAL DE</span>
              <span className="text-center font-semibold">
                SKA TRACKING AND SECURITY S.A. DE C.V.
              </span>
            </div>
          </div>

          {/* Botones */}
          <div className="mt-4 mb-4 px-4">
            <div className="flex justify-between">
              <Button
                color="red"
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(-1);
                }}
                className={`bg-red-500 hover:bg-red-600 text-white ${isDarkMode ? "bg-red-600 hover:bg-red-700" : ""}`}
              >
                Regresar
              </Button>
              <button
                type="submit"
                className={`rounded px-4 py-2 z-10 transition-colors ${isDarkMode ? "bg-green-600 hover:bg-green-700 text-white" : "bg-green-500 hover:bg-green-600 text-white"}`}
              >
                {" "}
                Guardar{" "}
              </button>
            </div>
          </div>

          {/* Footer */}
          <div className={`h-12 mt-8 flex items-center justify-center ${isDarkMode ? "bg-blue-800" : "bg-customBlue"}`}>
            <p className="text-sm text-white px-4">
              <span className="font-bold">DOCUMENTO CONFIDENCIAL</span>, prohibido
              su reproducción, copia o sacar este documento de las Instalaciones
              de Skyangel
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};
